import React from 'react';
import { connect } from 'react-redux';
import Dynamic from '../../pages/Dynamic/Dynamic';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  Breadcrumb,
  BreadcrumbItem,
  Row,
  Col,
  ListGroup,
  ListGroupItem
} from 'reactstrap';
import { Switch, Redirect, Route, Link, NavLink } from 'react-router-dom';

import pageComponents from './wspolpracownicy/';

const isTvpTuw =
  window.location.hostname === 'tvp-tuwpzuw.uspartner.pl' &&
  new Date('2022-10-24').getTime() > new Date().getTime();

const pracownicyData = [
  { title: 'Ogólne Informacje', component: 'Ogolne', link: 'opis/' },
  {
    title: 'Jak przystąpić do ubezpieczenia',
    component: 'ZasadyPrzystepowania',
    link: 'przystapienie/'
  },
  {
    title: 'Jak umówić się na wizytę',
    component: 'ZasadyUmawiania',
    link: 'umawianie/'
  },
  {
    title: 'Jak skorzystać z refundacji?',
    component: 'Refundacja',
    link: 'refundacja/'
  },
  { title: 'Reklamacje', component: 'Reklamacja', link: 'reklamacja/' },
  {
    title: 'Dokumenty do pobrania',
    component: 'DokumentyDoPobrania',
    link: 'dokumenty/'
  },
  {
    title: 'Nasze placówki',
    externalLink: 'https://www.pzuzdrowie.pl/nasze-placowki'
  },
  {
    title: 'Dostępne zakresy opieki medycznej',
    component: 'PorownaniePakietow',
    link: 'porownanie/'
  },
  {
    title: 'Pomoc',
    component: 'Pomoc',
    link: 'pomoc/'
  }
];

class PublicTwoColumnTemplate extends React.Component {
  render() {
    let currentBreadcrumb;

    const menu = pracownicyData.map((item) => {
      if (item.externalLink) {
        return (
          <ListGroupItem
            tag="a"
            key={item.title}
            href={item.externalLink}
            target="_blank"
            rel="noopener noreferrer"
            action>
            {item.title}
          </ListGroupItem>
        );
      }

      if (
        !currentBreadcrumb &&
        (`${this.props.match.path}${item.link}` ===
          this.props.location.pathname ||
          `${this.props.match.path}${item.link}` ===
            `${this.props.location.pathname}/`)
      ) {
        currentBreadcrumb = (
          <BreadcrumbItem active>{item.title}</BreadcrumbItem>
        );
      }

      const link = `${this.props.match.path}${item.link}`;
      return (
        <ListGroupItem tag={NavLink} key={item.title} to={link} action>
          {item.title}
        </ListGroupItem>
      );
    });

    const routes = pracownicyData.map((item) => {
      if (item.component) {
        return (
          <Route
            key={item.link}
            path={`${this.props.match.path}${item.link}`}
            component={pageComponents[item.component]}
          />
        );
      }
      return null;
    });
    return (
      <div>
        <Breadcrumb>
          <BreadcrumbItem>
            <Link to="/">{this.props.rootSection}</Link>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <Link to={this.props.match.path}>{this.props.section}</Link>
          </BreadcrumbItem>
          {currentBreadcrumb}
        </Breadcrumb>

        <Row>
          <Col xs="12" sm="3">
            <ListGroup>{menu}</ListGroup>
            {/* {!isTvpTuw && (
              <Button
                tag={Link}
                to="/wspolpracownicy/kup"
                color="primary"
                size="lg"
                className="sidebarDeclarationButton">
                <FontAwesomeIcon icon="arrow-alt-circle-right" />
                Wypełnij Deklarację
              </Button>
            )} */}
          </Col>
          <Col xs="12" sm="9">
            <Switch>
              {routes}
              {/* {this.props.isAuthenticated && (
                <Route
                  path={`/wspolpracownicy/kup/`}
                  render={(props) => (
                    <Dynamic
                      {...props}
                      guid="ca62f3d7-740f-4f74-9295-183080d61998"
                      // key={props.match.params.guid}
                    />
                  )}
                />
              )} */}
              <Redirect
                exact
                from="/wspolpracownicy"
                to="/wspolpracownicy/opis/"
              />
              <Redirect
                from="/wspolpracownicy/kup/"
                to={{
                  pathname: '/login',
                  state: { referrer: this.props.location.pathname }
                }}
              />
              <Redirect
                to={{
                  pathname: '/login',
                  state: { referrer: this.props.location.pathname }
                }}
              />
            </Switch>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.token !== null
    // username: state.auth.user.name,
    // menu: state.menu.data ? state.menu.data.menu : []
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    // logout: () => dispatch(logout())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PublicTwoColumnTemplate);
